import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '../../lib/utils.js';
import PropTypes from 'prop-types';
import OutlineTickIcon from '../Icon/OutlineTickIcon';

const RoundCheckbox = React.forwardRef(({ className, color, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            'rounded-full peer h-5 w-5 border border-primary shrink-0 shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary-foreground',
            color ? `border-${color} text-${color}-foreground` : 'border border-primary',
            className
        )}
        {...props}>
        <CheckboxPrimitive.Indicator style={{ backgroundColor: color && color, borderColor: color && color }} className={cn(`flex h-[100%] rounded-full items-center w-[100%] justify-center text-current`, !color && 'border border-primary bg-primary' )}>
            <OutlineTickIcon />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));

RoundCheckbox.displayName = CheckboxPrimitive.Root.displayName;

RoundCheckbox.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
};

export { RoundCheckbox };
